import {
  inboxConversationsResponseSchema,
  paths,
  type InboxConversationsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 这个 feature 的语义读操作名，失败会带上它，UI 据此挑文案。 */
export const getConversationsOperation = "conversations.list";

export type GetConversationsOperation = typeof getConversationsOperation;

export type GetConversationsFailure = BackendFailure<GetConversationsOperation>;

/**
 * 游标是后端给的不透明串，前端只原样回传；null 表示取第一页。
 */
export function getConversations(
  cursor: string | null,
  options: {
    fetch?: typeof globalThis.fetch;
    signal?: AbortSignal;
  } = {},
): ResultAsync<InboxConversationsResponse, GetConversationsFailure> {
  const params = new URLSearchParams();
  if (cursor !== null) params.set("cursor", cursor);
  const query = params.size === 0 ? "" : `?${params.toString()}`;

  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getConversationsOperation,
    parse: (payload) => inboxConversationsResponseSchema.parse(payload),
    path: `${paths.inboxConversations}${query}`,
    signal: options.signal,
  });
}
